import React from "react";
import Chart from "react-apexcharts";
import classNames from "classnames";

const StatisticsChartWidget2 = ({
  colors = ["#3C3D37"],
  containerClass = "",
  type = "bar",
  name = "Data",
  data = [],
  title = "",
  stats = "",
  trend = { textClass: "", value: "" },
}) => {
  // Default options
  const options = {
    chart: {
      sparkline: {
        enabled: true,
      },
    },
    plotOptions: {
      bar: {
        columnWidth: "80%",
      },
    },
    xaxis: {
      crosshairs: {
        width: 1,
      },
    },
    stroke: {
      width: type ? 2 : 0,
      curve: "smooth",
    },
    colors: colors,
    tooltip: {
      theme: "dark",
      fixed: {
        enabled: false,
      },
      x: {
        show: false,
      },
      y: {
        title: {
          formatter: () => "",
        },
      },
      marker: {
        show: false,
      },
    },
  };

  // Chart data
  const series = [{ name: name, data: data }];

  return (
    <div className={containerClass}>
      <div className="row justify-content-between">
        <div className="col-md-6 col-lg-6 w-50 ">
          <h6 style={{fontSize:"14px"}} className="text-muted mt-0 fs-14">{title}</h6>
          <h3 style={{fontSize:"18px"}} className="my-2">{stats}</h3>
          <h6 className={classNames("mb-0", trend.textClass)}>{trend.value}</h6>
        </div>

        <div className="col-md-6 col-lg-6 w-50">
          <div className="">
            <Chart
              options={options}
              series={series}
              type={type}
              height={60}
              width={"100%"}
            />
          </div>
        </div>
      </div>
      
    </div>
  );
};

export default StatisticsChartWidget2;
